import { StreamCategory } from '@/__generated__/graphql.ts';

export const streamCategories = Object.entries(StreamCategory).map((item) =>
  item[1] === StreamCategory.Osint
    ? {
        title: StreamCategory.Osint,
        value: item[1],
      }
    : {
        title: item[1]
          .replace(/_/g, '')
          .toLowerCase()
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        value: item[1],
      },
);

export const streamFilterCategories = [
  { title: 'All', value: 'all' },
  ...streamCategories,
];

export const getStreamCategoryTitle = (value: StreamCategory) => {
  return streamCategories.find((item) => item.value === value)?.title;
};

export const categorySelectOptions = streamCategories.map(
  ({ title, value }) => ({
    content: title,
    value,
  }),
);
